import { AdditionalField } from './additional-field.model';
import { Analysis } from 'projects/dop-ordering/src/public-api';
import { SpecificationViewModel } from './specification/specification-view-model.model';
import { TestParameter } from './specification/test-parameter.model';
import { AnalysesResponse } from './specification/analyses-response.model';
import { SpecificationResponse } from './specification/specification-response.model';
import { AnalysisDisplay } from './analysis-display.model';
import { AttachDocument } from './attach-document';
import { ProductMatrix } from 'projects/dop-ordering/src/lib/models/product-matrix.model';
import { SampleAnalysisItemsType } from './monograph/sample-analysis-items-type.model';
import { FavoriteSample } from './favorite-sample.model';

export class Sample {
    specifications?: SpecificationViewModel[] = [];
    testParameters?: TestParameter[] = [];
    planningLines?: AnalysesResponse[] = [];
    specificationResponses?: SpecificationResponse[] = [];
    analysisDisplay?: AnalysisDisplay[] = [];
    mandatoryAnalysisDisplay?: AnalysisDisplay[] = [];
    attachDocuments?: AttachDocument[] = [];
    analysisItemsOfType?: SampleAnalysisItemsType;
    displayAdditionalFields?: AdditionalField[] = [];
    favorite?: FavoriteSample = {};
    constructor(
        public sampleCode?: string,
        public eurofinsSampleCode?: string,
        public customerReference?: string,
        public description?: string,
        public comment?: string,
        public lotNumber?: string,
        public analyses?: Analysis[],
        public priorityLevel?: string,
        public priorityLevelDisplayName?: string,
        public analyticalReportGroupingRule?: string,
        public isSelected?: boolean,
        public isSpecificationsAdded?: boolean,
        public isSpecificationsEdited?: boolean,
        public location?: string,
        public additionalFields?: AdditionalField[],
        public resultConversion?: string,
        public regulation?: string,
        public servingUnit?: ServingUnit,
        public servingUnitNumeratorName?: string,
        public servingUnitNumeratorCode?: string,
        public servingUnitDenominatorName?: string,
        public servingUnitDenominatorCode?: string,
        public servingSize?: string,
        public price?: string,
        public priceValue?: number,
        public isExisting?: boolean,
        public barcode?: string,
        public product?: ProductMatrix,
    ) { }
}

export class Analyses {
    title?: string;
    pack?: Package;
    category?: string;
    tests?: Test[];
    price?: number;
    isFav?: boolean;
    constructor(
        title: string,
        pack: Package,
        category: string,
        tests?: Test[],
        price?: number,
        isFav?: boolean
    ) {
        this.tests = [];
    }
}

export class Specification {
    constructor(
        analyses: string,
        parameters: Parameter[]
    ) { }
}

class Parameter {
    constructor(
        title?: string,
        standardUnit?: Unit,
        servingUnit?: Unit
    ) { }
}

class Unit {
    constructor(
        title?: string,
        target?: string,
        min?: number,
        max?: number
    ) { }
}

class Package {
    constructor(
        title?: string,
        price?: number,
        isFav?: boolean
    ) { }
}

class Test {
    constructor(
        code?: string,
        title?: string,
        price?: number,
        isFav?: boolean,
        priority?: boolean
    ) { }
}

export class ServingUnit {
    id?: number;
    code?: string;
    name?: string;
}
